<!--
アンケート回答
URL：answer/:url
-->

<template>
  <div>
    <v-container v-if="isOpen" style="max-width: 800px">
      <alert :errors="errors" css_class="ma-1"></alert>
      <v-card elevation="5" class="ma-4">
        <v-card-title class="custom-card-title">
          {{ question.title }}
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              {{ question.description }}
              <v-divider class="mt-2 mb-2"></v-divider>
              <v-icon class="mr-1 red--text caption">mdi-asterisk</v-icon>
              <span class='red--text'>必須の質問です</span>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card
          v-for="(item, index) in question.items"
          :key="index"
          elevation="5"
          class="ma-4"
      >
        <v-card-title class="custom-card-subtitle jutsity-between">
          {{ item.description }}
          <v-icon v-if="item.required" class="ml-1 mb-3 red--text caption">mdi-asterisk</v-icon>

        </v-card-title>
        <v-card-text>
          <template v-if="item.type === 'text'">
            <v-row>
              <v-col cols="12">
                <v-textarea
                  color="#0ddbc7"
                  outlined
                  hide-details="auto"
                  v-model="formData.items[index].value"
                ></v-textarea>
              </v-col>
            </v-row>
          </template>
          <template v-else-if="item.type === 'radio'">
            <v-row>
              <v-col cols="12">
                <v-radio-group>
                  <v-radio
                    v-for="(option, op_index) in item.options"
                    :key="op_index"
                    :label="option.value"
                    :name="'item' + item.id"
                    :id="'option' + option.id"
                    v-model="formData.items[index].options[op_index].question_option_id"
                    @change="updateFormData(index, option.id)"
                    ></v-radio>                    
                </v-radio-group>
              </v-col>
            </v-row>
          </template>
          <template v-else-if="item.type === 'checkbox'">
            <v-row>
              <v-col cols="12">
                <v-checkbox 
                  v-for="(option, op_index) in item.options"
                  :key="op_index"
                  :label="option.value"
                  v-model="formData.items[index].options[op_index].checked"
                  hide-details="auto"
                  class="mt-2 pt-0"                  
                ></v-checkbox>
              </v-col>
            </v-row>
          </template>
        </v-card-text>
      </v-card>

      <v-row justify="center" style="text-align: center">
        <v-col cols="6">
          <v-btn
              color="secondary"
              outlined
              style="font-size: 24px"
              class="ma-2"
              width="200"
              height="50"
              @click="cancel"
          >やめる
          </v-btn>
        </v-col>
        <v-col cols="6">
          <v-btn
              color="primary"
              style="font-size: 24px"
              class="ma-2"
              width="200"
              height="50"
              @click="inputCheck"
          >保存
          </v-btn>
        </v-col>
      </v-row>
    </v-container>

    <v-container v-else style="max-width: 800px"> 
      <v-card elevation="5" class="ma-4">
        <v-card-title class="custom-card-subtitle">
          このアンケートは現在回答できません。
        </v-card-title>
      </v-card>

    </v-container>
  </div>
</template>

<script>
import Api from "@/logic/api/api.js";
import Alert from "../../components/common/alert.vue";
import AlertBuilder from "../../logic/common/alert-contents";
import valueMapper from "../../logic/common/value-mapper";

export default {
  components: {
    alert: Alert,
  },
  data() {
    return {
      url: '',
      errors: [],

      question: {
        title: null,
        description: null,
        started_at: null,
        ended_at: null,
        items: [],
      },

      formData: {
        question_id: null,
        items: [],
      },
    };
  },
  mounted() {
    this.url = this.$route.params.url;

    this.id = Number(this.$route.params.uid);
    this.$store.commit("setWaiting", true);
    // アンケートを取得する
    Api.call("/question/get", {"url": this.url})
      .then((result) => {
        this.$store.commit("setWaiting", false);
        this.question.title = result.title;
        this.question.description = result.description;
        this.question.started_at = result.started_at;
        this.question.ended_at = result.ended_at;
        this.question.items = result.items
          .map(el => ({...el, options: this.typeHasOption(el.type) ? el.options : null}));
        this.formData.items = result.items
          .map(el => ({
            question_item_id: el.id, 
            value: null, 
            options: this.typeHasOption(el.type) ? el.options.map(op => ({question_option_id: op.id, checked: false})) : null})
          );
        this.formData.question_id = result.id;
      })
      .catch((result) => {
        this.$store.commit("setWaiting", false);
        Api.resolve(result);
      });
  },
  computed: {
    isOpen() {
      // アンケート実施期間かどうかの確認
      const currentTime = new Date();
      const startTime = new Date(this.question.started_at);
      if (this.question.ended_at) {
        const endTime = new Date(this.question.ended_at);
        return currentTime >= startTime && currentTime < endTime.setDate(endTime.getDate() +1);
      } else {
        return currentTime >= startTime;
      }      
    },
  },
  methods: {
    updateFormData(item_index, option_id) {
      this.formData.items[item_index].options.forEach(op => {
        op.checked = op.question_option_id == option_id ? true : false;
      });
    },

    typeHasOption(type) {
      return type === 'radio' || type === 'checkbox';
    },

    /**
     * エラーメッセージをクリアする
     */
    clearMessage() {
      this.errors = [];
    },

    /**
     * エラーメッセージを表示する
     */
    showMessage(error) {
      this.errors.push(error);
      window.scrollTo(0, 0);
    },

    /**
     * 保存ボタン押下時に入力内容をチェックする
     */
    inputCheck() {
      this.clearMessage();
      let check = true;

      this.question.items.forEach((item, index) => {
        if(item.required) {
          if(item.type === 'text') {
            if(!this.formData.items[index].value) {
              this.showMessage(AlertBuilder.error("テキストを入力してください"));
              check = false;
              return;
            }
          } else {
            if(this.formData.items[index].options.filter(option => option.checked === true).length === 0){
              this.showMessage(AlertBuilder.error("選択肢を選択してください"));
              check = false;
              return;
            }
          }
        }
      })
      if(check) {
        this.register();
      } else {
        return;
      }

    },

    register() {
      let updateUrl = "/answer/update";
      let postData = {...this.formData};

      this.$store.commit("setWaiting", true);

      Api.call(updateUrl, postData)
          .then(() => {
            this.$store.commit("setWaiting", false);
            this.$router.push("/answer/completed");
          })
          .catch((error) => {
            this.$store.commit("setWaiting", false);
            const message = valueMapper
                .map({
                  400: AlertBuilder.error("更新に失敗しました"),
                  401: AlertBuilder.invalid(),
                  403: AlertBuilder.error("権限がありません"),
                  409: AlertBuilder.error("編集が競合しています"),
                })
                .getOrElse(error.status, AlertBuilder.invalid());
            if (message.isInvalid) {
              Api.resolve(error);
            } else {
              this.showMessage(message);
            }
          });
    },
    cancel() {
      this.$router.push("/information");
      // this.$router.go({path: this.$router.currentRoute.path, force: true});
    },
  },
};
</script>

<style scoped>
.card-error {
  background-color: #ffdbe2;
}

.custom-card-title {
  font-size: 32px;
  color: #333;
  line-height: 1.5;
}

.custom-card-subtitle {
  font-size: 24px;
  line-height: 1.5;
}

.custom-card-text {
  font-size: 24px;
  line-height: 1.3;
}
</style>
